import { Bytes } from "@/utils/unit";
import { parseArray } from "./array";
import { parseDate } from "./date";
import { parseNumber } from "./number";

/**
 * Parse search params from a URLSearchParams object
 * @param searchParams - The URLSearchParams object to parse
 * @returns The parsed search params
 */
export const parseSearchParams = (
  searchParams: URLSearchParams
): Record<string, any> => {
  const values: Record<string, any> = {};
  const dateObj: { from: Date | null; to: Date | null } = {
    from: null,
    to: null,
  };
  const sizeObj: {
    minColumns?: number;
    maxColumns?: number;
    minRows?: number;
    maxRows?: number;
    minSize?: number;
    maxSize?: number;
  } = {};

  searchParams.forEach((value, key) => {
    if (key === "country_id__in") {
      values.country_id = parseArray(value);
    } else if (key === "datetime_created__date__gte") {
      const dateValue = parseDate(value);
      if (dateValue !== null) {
        dateObj.from = dateValue;
      }
    } else if (key === "datetime_created__date__lte") {
      const dateValue = parseDate(value);
      if (dateValue !== null) {
        dateObj.to = dateValue;
      }
    } else if (key === "category__in") {
      values.category = parseArray(value);
    } else if (key === "column_count__gte") {
      const numValue = parseNumber(value);
      if (numValue !== null) {
        sizeObj.minColumns = numValue;
      }
    } else if (key === "column_count__lte") {
      const numValue = parseNumber(value);
      if (numValue !== null) {
        sizeObj.maxColumns = numValue;
      }
    } else if (key === "row_count__gte") {
      const numValue = parseNumber(value);
      if (numValue !== null) {
        sizeObj.minRows = numValue;
      }
    } else if (key === "row_count__lte") {
      const numValue = parseNumber(value);
      if (numValue !== null) {
        sizeObj.maxRows = numValue;
      }
    } else if (key === "byte_count__gte") {
      const numValue = parseNumber(value);
      if (numValue !== null) {
        sizeObj.minSize = Math.round(Bytes.megabytes(numValue));
      }
    } else if (key === "byte_count__lte") {
      const numValue = parseNumber(value);
      if (numValue !== null) {
        sizeObj.maxSize = Math.round(Bytes.megabytes(numValue));
      }
    } else if (value.includes(",") && !key.includes("__")) {
      (values as any)[key] = parseArray(value);
    } else {
      const dateValue = parseDate(value);
      if (dateValue !== null && !key.includes("__")) {
        if (!dateObj.from) {
          dateObj.from = dateValue;
        } else if (!dateObj.to) {
          dateObj.to = dateValue;
        }
      } else {
        (values as any)[key] = value;
      }
    }
  });

  if (dateObj.from || dateObj.to) {
    values.date = dateObj;
  }

  if (Object.keys(sizeObj).length > 0) {
    values.size = sizeObj;
  }

  return values;
};
